import { TextLargeParagraph } from '@carboncopyco/ui';
import { TitleCard } from '../../InfoPageCards/TitleCard';
import { ClonePageTabLayout } from '../ClonePageTabLayout';
import { RevisionsTable } from './RevisionsTable';

export const HistoryTab = () => {
  return (
    <ClonePageTabLayout>
      <div>
        <TitleCard
          radius
          header={
            <div className="flex p-6">
              <TextLargeParagraph
                color="text-ds-natural-700"
                label="Version history"
              />
            </div>
          }
        >
          <RevisionsTable />
        </TitleCard>
      </div>
    </ClonePageTabLayout>
  );
};
